"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var execCommand_1 = require("../utils/execCommand");
/**
 * Toggle strikethrough at selection
 * If selection is collapsed, it will only affect the input after caret
 * If selection contains only strikethrough text, the strikethrough style will be removed
 * If selection contains only normal text, strikethrough style will be added to the whole selected text
 * If selection contains both strikethrough and normal text, strikethrough stlye will be added to the whole selected text
 * @param editor The editor instance
 */
function toggleStrikethrough(editor) {
    execCommand_1.default(editor, "strikeThrough" /* StrikeThrough */);
}
exports.default = toggleStrikethrough;
//# sourceMappingURL=toggleStrikethrough.js.map